import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from '@material-ui/core/Typography';
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import SimilarGroupsSearch from "./SimilarGroupsSearch";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  grow: {
    flexGrow: 1,
  },
  title: {
    //marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SimilarGroupDialog(props) {
  const classes = useStyles();
  const { open, onClose, isManage, currentProductMatchingGroup } = props;
  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  const dialogTitle = isManage
    ? `Manage similar groups of #${currentProductMatchingGroup &&
      currentProductMatchingGroup.id}`
    : `Select a similar group to match with #${currentProductMatchingGroup &&
      currentProductMatchingGroup.id}`;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      scroll={"paper"}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">{dialogTitle}
      <Typography color="textSecondary" variant="body2">
       {currentProductMatchingGroup&&`${currentProductMatchingGroup.fullname} ${currentProductMatchingGroup.size}`}
      </Typography>
      </DialogTitle>
      <DialogContent dividers={true}>
        <DialogContentText
          id="scroll-dialog-description"
          ref={descriptionElementRef}
          tabIndex={-1}
        >
          <SimilarGroupsSearch
            isManage={isManage}
            currentProductMatchingGroup={currentProductMatchingGroup}
            doClose={onClose}
          />
        </DialogContentText>
      </DialogContent>
      {/* <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onClose} color="primary">
          Subscribe
        </Button>
      </DialogActions> */}
    </Dialog>
  );
}
